// extracted by mini-css-extract-plugin
export default {"tooltipContent":"FavoritesButton_tooltipContent__n1zAx"};